import React from 'react'
import COLORS from '../../styles/colors'

const defaultSize = {
  height: 12,
  width: 15,
}

interface IPropType {
  style?: object
  color?: string
}

function SvgComponent({ style, color = COLORS.greyscale.white }: IPropType) {
  return (
    <svg style={{ ...defaultSize, ...style }} viewBox='0 0 15 12'>
      <path
        d='M5.846 11.626a.779.779 0 01-1.1 0l-4.4-4.4a1.169 1.169 0 010-1.653l.551-.551a1.169 1.169 0 011.653 0l2.745 2.746L12.72.343a1.169 1.169 0 011.653 0l.551.551a1.169 1.169 0 010 1.653zm0 0'
        fill={color}
      />
    </svg>
  )
}

export default SvgComponent
